<template>
    <v-main>
        <v-layout>
        <v-flex xs12 sm8 offset-sm2>            
            <h1>Contact Us</h1>
            <iframe id="JotFormIFrame-202125261146039" onload="window.parent.scrollTo(0,0)" allowtransparency="true" allowfullscreen="true" allow="geolocation; microphone; camera" :src="formURL" frameborder="0" style="width: 1px; min-width: 100%; height:1190px; border:none;" scrolling="no" > </iframe>       
        </v-flex>
        </v-layout>
    </v-main>
</template>

<script>
export default {
    data() {
        return {
            formURL: "https://form.jotform.com/202125261146039"
        }
    },
    // head: {
    //     script: [
    //         { type: 'text/javascript', src: "https://form.jotform.com/202125261146039", async: true, body: true}
    //     ]
    // }
}
</script>

<style scoped>
    h1 {
        text-align: center;
    }
</style>